import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses, problemCards, volumes } from '../data/content';
import { HeroSection } from '../components/HeroSection';
import { ProblemCard } from '../components/ProblemCard';
import { ProductIntro } from '../components/ProductIntro';
import { VolumeCard } from '../components/VolumeCard';
import { InsideLookSection } from '../components/InsideLookSection';
import { BonusCard } from '../components/BonusCard';
import { BenefitsGrid } from '../components/BenefitsGrid';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { TeachingSituations } from '../components/TeachingSituations';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQAccordion } from '../components/FAQAccordion';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
type LandingPageProps = {
  guaranteeEnabled: boolean;
  testimonialsEnabled: boolean;
  bonusReferencePricesEnabled: boolean;
  salesPopupEnabled: boolean;
};
export function LandingPage({
  guaranteeEnabled,
  testimonialsEnabled,
  bonusReferencePricesEnabled,
  salesPopupEnabled
}: LandingPageProps) {
  return <div className="min-h-screen w-full bg-outer font-body" data-id="element-218" data-mp="3db3n6ye47ewu">
      <main className="mx-auto w-full max-w-[768px] overflow-hidden bg-white" data-id="element-219" data-mp="3i9olutdpxqj6">
        <HeroSection guaranteeEnabled={guaranteeEnabled} data-id="element-220" data-mp="3n8hry0qoef9b" />

        <section className="space-y-2.5 bg-surface px-4 py-4 md:px-12 md:py-6" data-id="element-221" data-mp="3n6yai6ta9y5y">
          {problemCards.map(c => <ProblemCard key={c.title} {...c} data-id="element-222" data-mp="3r80bot6rgkak" />)}
        </section>

        <ProductIntro data-id="element-223" data-mp="3a04897kca8" />

        <section className="bg-white px-4 pb-6 md:px-12 md:pb-8" data-id="element-224" data-mp="1pfbacp47pk">
          <h2 className="text-center font-heading text-[24px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-navy md:text-[32px]" data-id="element-225" data-mp="1wxdgdjvm2cji">
            What's Included
          </h2>
          <div className="mt-3 space-y-2.5" data-id="element-226" data-mp="3573wkn2nax3t">
            {volumes.map(({
            number,
            ...v
          }) => <VolumeCard key={number} label={`Volume ${number}`} {...v} data-id="element-227" data-mp="30811nvgdq79k" />)}
          </div>
        </section>

        <InsideLookSection data-id="element-228" data-mp="3e8bu32xc7twu" />

        <section className="bg-navy px-4 py-6 md:px-12 md:py-8" data-id="element-229" data-mp="3e4ebqjil36e0">
          <h2 className="flex items-center justify-center gap-2 text-center font-heading text-[21px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-gold md:text-[32px]" data-id="element-230" data-mp="3964em3datvpr">
            <GiftIcon className="h-6 w-6 shrink-0 md:h-8 md:w-8" strokeWidth={2.5} aria-hidden data-id="element-231" data-mp="3j528zmxeojgo" />
            Plus, get 5 free professional bonuses!
          </h2>
          <p className="mx-auto mt-1.5 max-w-[560px] text-center text-[14px] leading-[1.4] text-onNavyMuted md:text-[15px]" data-id="element-232" data-mp="3svwzj3hoq57x">
            Five additional resources designed to provide even more flexibility when teaching aquatic fitness classes.
          </p>
          <div className="mt-3 space-y-2.5" data-id="element-233" data-mp="5ss3ycryqrm0">
            {bonuses.map(b => <BonusCard key={b.number} {...b} showReferencePrice={bonusReferencePricesEnabled} data-id="element-234" data-mp="pe21q8hwpee7" />)}
          </div>
        </section>

        <BenefitsGrid data-id="element-235" data-mp="fekz5zxybgmg" />
        <OfferSection showReferencePrices={bonusReferencePricesEnabled} guaranteeEnabled={guaranteeEnabled} data-id="element-236" data-mp="ff2wz109i2wh" />
        {guaranteeEnabled && <GuaranteeSection data-id="element-237" data-mp="kc2zj1xwkniu" />}
        <TeachingSituations data-id="element-238" data-mp="kfh3ufq4n6sx" />
        {testimonialsEnabled && <TestimonialsSection data-id="element-239" data-mp="6l7xa8hwt4o8" />}
        <FAQAccordion data-id="element-240" data-mp="6ky4kd5hcjeu" />
        <FinalCTA guaranteeEnabled={guaranteeEnabled} data-id="element-241" data-mp="bczhm1ah2e5x" />
        <Footer data-id="element-242" data-mp="beiwpoke6j64" />
      </main>
      {salesPopupEnabled && <PurchasePopup data-id="element-243" data-mp="3stpqz89vr5dp" />}
    </div>;
}